import { Dialog, Typography } from "@mui/material";
import {
  DialogButtonWrapper,
  DialogWrapper,
  DialogButtonConfirm,
  DialogButtonCancel,
  StyledDialogTitle,
} from "./style";

export interface ConfirmationDialogProps {
  confirmationTitle: string;
  confirmationMessage: string;
  isOpen: boolean;
  onClose: (confirmationState: boolean) => void;
}

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const { confirmationTitle, confirmationMessage, isOpen, onClose } = props;

  return (
    <Dialog open={isOpen}>
      <StyledDialogTitle>{confirmationTitle}</StyledDialogTitle>
      <DialogWrapper>
        <Typography>{confirmationMessage}</Typography>
        <DialogButtonWrapper>
          <DialogButtonConfirm onClick={() => onClose(true)} disabled={false}>
            Confirm
          </DialogButtonConfirm>
          <DialogButtonCancel onClick={() => onClose(false)} disabled={false}>
            Cancel
          </DialogButtonCancel>
        </DialogButtonWrapper>
      </DialogWrapper>
    </Dialog>
  );
};

export default ConfirmationDialog;
